import React from 'react';
import { Route } from 'react-router-dom';

type Props = {
  path: string | string[];
  component: Function;
  layout: Function;
};

const RouteLayoutWrapper = ({ path, layout: Layout, component: Component, ...rest }: Props) => {
  return (
    <Route
      {...rest}
      path={path}
      render={props => (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default RouteLayoutWrapper;
